import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import MenuColor from './components/MenuColor';
import ProjectFilter from './components/ProjectFilter';
import Cursor from './components/Cursor';
import StickyMenu from './components/StickyMenu';
import ResponsiveVideo from './components/ResponsiveVideo';
import VideoPlayer from './components/VideoPlayer';
import Slider from './components/Slider';
import FadeInOutImages from './components/FadeInOutImages';
import Usp from './components/Usp';
import StickySlides from './components/StickySlides';
import ParallaxEffectHero from './components/ParallaxEffectHero';
import CardClickArea from './components/CardClickArea';
import AutoplayVideos from './components/AutoplayVideos';


export class AalbertsApp {
	constructor() {
		Promise.all([AalbertsApp.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		new Menu();
		new MenuColor();
		new Cursor();
		new ParallaxEffectHero();

		VideoPlayer.init();
		ResponsiveVideo.init();

		const $autoplayvideo = document.querySelector('[data-autoplay-video]');
		if ($autoplayvideo) {
			new AutoplayVideos();
		}

		const $projectfilter = document.querySelector('[data-projectfilter-container]');
		if ($projectfilter) {
			new ProjectFilter($projectfilter);
		}

		document.querySelectorAll('[data-slider]').forEach((elm) => {
			new Slider(elm);
		});

		document.querySelectorAll('[data-fadeinout-images]').forEach((elm) => {
			new FadeInOutImages(elm);
		});

		document.querySelectorAll('[data-usps]').forEach((elm) => {
			new Usp(elm);
		});

		document.querySelectorAll('[data-fadein-slide]').forEach((elm) => {
			new StickySlides(elm);
		});

		document.querySelectorAll('[data-header]').forEach((el) => {
			new StickyMenu(el);
		});

		document.querySelectorAll('[data-card-link]').forEach((el) => {
			new CardClickArea(el);
		});

	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new AalbertsApp();